import { createAction, props } from '@ngrx/store';

export const loadIfaSearchProducts = createAction('[IfaSearchProducts] Load IfaSearchProducts', props<{ request: any }>());

export const loadIfaSearchProductsSuccess = createAction('[IfaSearchProducts] Load IfaSearchProducts Success', props<{ response: any }>());

export const loadIfaSearchProductsFailure = createAction(
  '[IfaSearchProducts] Load IfaSearchProducts Failure',
  props<{ error: Error | any }>()
);
